/**
 * Deutsche Endnutzertexte für invite-member, resend-invite und revoke-invite.
 * Rohtexte und Statuscodes bleiben in der Konsole.
 */

export const INVITE_ERROR_TEXT = {
  alreadyMember: "Diese Person ist bereits Mitglied im Verein.",
  disabled:
    "Diese Person ist deaktiviert. Reaktiviere sie in der Mitgliederliste.",
  openInvite: "Für diese E-Mail-Adresse gibt es schon eine offene Einladung.",
  adminRole:
    "Nur die Administration darf Einladungen mit der Rolle Administration verschicken.",
  resendAdminRole:
    "Nur die Administration darf Einladungen mit der Rolle Administration erneut senden.",
  forbidden:
    "Nur Administration, Vorstand oder Superadmin dürfen Einladungen verwalten.",
  generic: "Die Einladung konnte nicht gesendet werden. Bitte versuche es erneut.",
  revoke: "Die Einladung konnte nicht widerrufen werden. Bitte versuche es erneut.",
  revokeNotOpen: "Nur offene Einladungen können widerrufen werden.",
  resendNotOpen: "Nur offene Einladungen können erneut gesendet werden.",
} as const;

export function mapInviteError(input: {
  status?: number | null;
  message?: string | null;
  action?: "invite" | "resend" | "revoke";
}): string {
  const message = (input.message ?? "").trim();
  const lower = message.toLowerCase();
  const status = input.status ?? null;

  if (/deaktiviert/.test(lower)) return INVITE_ERROR_TEXT.disabled;
  if (input.action === "revoke" && /nur offene einladungen/.test(lower)) {
    return INVITE_ERROR_TEXT.revokeNotOpen;
  }
  if (input.action === "resend" && /nur offene einladungen/.test(lower)) {
    return INVITE_ERROR_TEXT.resendNotOpen;
  }
  if (/offene einladung/.test(lower)) return INVITE_ERROR_TEXT.openInvite;
  if (/bereits mitglied/.test(lower)) return INVITE_ERROR_TEXT.alreadyMember;
  if (/erneut senden/.test(lower) && /rolle administration/.test(lower)) {
    return INVITE_ERROR_TEXT.resendAdminRole;
  }
  if (/rolle administration/.test(lower)) return INVITE_ERROR_TEXT.adminRole;
  if (status === 403 || /dürfen einladungen verwalten/.test(lower)) {
    return INVITE_ERROR_TEXT.forbidden;
  }
  if (input.action === "revoke") return INVITE_ERROR_TEXT.revoke;
  return INVITE_ERROR_TEXT.generic;
}
